<script>
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();
  const SLOTS = $$props.$$slots || {};

  export let checked = false;
  export let childrenChecked = false;
  export let label = null;

  let toggleCheck = function () {
    checked = !checked;
    dispatch('change', { checked: checked });
  };
</script>

<style style="text/scss" lang="scss">
  .checkbox {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    margin: 0px;

    .checkbox-input {
      height: 20px;
      width: 20px;
      border-radius: 7px;
      cursor: pointer;
      margin-top: 2px;
      position: relative;
      border: 2px solid #dfdaf1;
    }

    .checkbox-input-active {
      background-color: #a893f9;
      border: 2px solid transparent;
    }

    .checkbox-label {
      margin-left: 18px;
    }
  }
</style>

<div class="checkbox {$$props.class}" on:click|preventDefault|stopPropagation={toggleCheck}>
  <div class="checkbox-input {$$props.inputClass}" class:checkbox-input-active={checked || childrenChecked}>
    {#if checked}
      <svg
        style="position: absolute; left: calc(50% - 6px); top: calc(50% - 4.5px)"
        width="12"
        height="9"
        viewBox="0 0 12 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.81055 4.32353L4.59529 7.5L9.85536 1.5"
          stroke="white"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    {:else if childrenChecked}
      <svg
        style="position: absolute; left: calc(50% - 6px); top: calc(50% - 4.5px)"
        width="12"
        height="9"
        viewBox="0 0 12 4"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.16699 1.99935C1.16699 1.53911 1.54009 1.16602 2.00033 1.16602H10.0003C10.4606 1.16602 10.8337 1.53911 10.8337 1.99935C10.8337 2.45959 10.4606 2.83268 10.0003 2.83268H2.00033C1.54009 2.83268 1.16699 2.45959 1.16699 1.99935Z"
          fill="white"
          stroke="white"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    {/if}
  </div>

  {#if SLOTS.content}
    <slot name="content" />
  {/if}

  {#if label}
    <span class="checkbox-label {$$props.labelClass}">
      {@html label}
    </span>
  {/if}
</div>
